import { createSelector } from 'reselect';
import ContentRoutes from 'ContentUtils/Routes';
// @ts-ignore untyped JS module
import { getHasStagingDomain } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getIsStagingV2 } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getSubcategory, getContentModelId, getPreviewKey } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getAvailableDomains } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getPageSettingsFullUrl } from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
import { buildSandboxUrl } from 'page-editor-ui/utils/urlUtils';
const getReturnToDashboardUrl = createSelector([getCategoryId, getSubcategory], (categoryId, subcategory) => ContentRoutes.dashboard(categoryId, subcategory));
export const getStagedPageLiveDomainName = state => state.stagedPage && state.stagedPage.liveDomainName || null;
export const getStagedPageStatus = state => state.stagedPage && state.stagedPage.status || null;

// Undefined when unresolved, so callers fall back to the bare staging dashboard.
const getStagingDomainId = createSelector([getAvailableDomains, getStagedPageLiveDomainName], (domains, liveDomainName) => {
  var _domains$find;
  return liveDomainName ? (_domains$find = domains.find(domain => domain.domain === liveDomainName)) === null || _domains$find === void 0 ? void 0 : _domains$find.id : undefined;
});
const STAGED_PAGE_STATE_BY_STATUS = {
  DRAFT: 'stagedDraft',
  PROOF: 'stagedProof'
};

// The editor is only reachable from a single page on a single domain, so manage is always the tab to return to.
export const getStagingDashboardUrl = createSelector([getStagingDomainId, getStagedPageStatus], (domainId, stagedPageStatus) => ContentRoutes.staging({
  domainId,
  tab: 'manage',
  stagedPageState: stagedPageStatus ? STAGED_PAGE_STATE_BY_STATUS[stagedPageStatus] : undefined
}));
export const getDashboardUrl = basicSelectorWithStats(state => {
  if (getIsStagingV2(state)) {
    return getStagingDashboardUrl(state);
  }

  // Staging v1, where the page lives on the staging domain itself.
  // That domain's id is not the one the staging route expects, so there is nothing to narrow the dashboard down with.
  if (getHasStagingDomain(state)) {
    return ContentRoutes.staging();
  }
  return getReturnToDashboardUrl(state);
});
export const getStagedPageSandboxDomainName = state => state.stagedPage && state.stagedPage.sandboxDomainName;
const getStagedPagePreviewUrl = state => state.stagedPage && state.stagedPage.previewUrl;
export const getPublishedOrStagingUrl = createSelector([getPageSettingsFullUrl, getIsStagingV2, getStagedPageSandboxDomainName], (publishedURL, isStagingV2, sandboxDomainName) => {
  if (isStagingV2 && sandboxDomainName) {
    return buildSandboxUrl(sandboxDomainName, publishedURL);
  }
  return publishedURL;
});
export const getShareablePreviewUrl = createSelector([getContentModelId, getPreviewKey, getPageSettingsFullUrl, getIsStagingV2, getStagedPagePreviewUrl], (id, previewKey, publishedURL, isStagingV2, stagedPreviewUrl) => {
  if (isStagingV2 && stagedPreviewUrl) {
    return stagedPreviewUrl;
  }
  return `${publishedURL}?hs_preview=${previewKey}-${id}`;
});